// 3D Model constants for TO packages (TO-92, TO-220, TO-252, TO-263)
export const toPinMarkerSize = 0.0004; // Larger for power packages
export const toPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 400;
export const toPinMarkerOffsetZ = 0.000001;
export const toPinMarkerSegments = 32;
// TO-specific constants for tab/heatsink
export const toTabThickness = 0.001; // 1mm tab thickness
//# sourceMappingURL=toConstants.js.map